// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"9609a6c6","66":"ca7191cd","488":"a983d68f","538":"146381b0","877":"3cdfb922"}[chunkId] + ".chunk.js";
};